// ── EVIDENCE COLLECTION VISIBILITY — one read, and only a read ─────────────────────────────────
//
// ⚠ THERE IS NO MUTATION IN THIS FILE AND THAT IS THE DESIGN. B-EVIDENCE-COLLECTION-VISIBILITY is
// read-only: no "Run now", no retry, no cancel. The sweep's schedule belongs to the sweep, and a
// client button that started one would be a write path into a scheduler this feature may not touch.
//
// ⚠ ITS FAILURE MUST STAY LOCAL. This query sits on a page that already works without it, so the
// consumer renders an error state for this panel alone — an evidence-collection outage must not
// take down the repository settings the admin came here to read.

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { BindingCollectionVisibility } from '@/api/types/evidence-collection.types';

export const EVIDENCE_COLLECTION_STATUS_KEY = ['evidence-collection', 'status'] as const;

export function useEvidenceCollectionStatus() {
  return useQuery({
    queryKey: EVIDENCE_COLLECTION_STATUS_KEY,
    queryFn: async () => {
      const { data } = await apiClient.get('/compliance/evidence/collection-status');
      return (data.data ?? []) as BindingCollectionVisibility[];
    },
  });
}
